import { jsx as _jsx } from "react/jsx-runtime";
import { Children, Fragment, cloneElement, forwardRef, isValidElement, useState } from 'react';
import { GROUP } from '../../../constants';
import { callAll } from '../../../utils';
const isInteractiveElement = (element) => {
    const interactiveTypes = ['input', 'textarea', 'select', 'button'];
    const interactiveProps = ['onChange', 'onClick', 'onInput', 'onBlur'];
    if (interactiveTypes.includes(element === null || element === void 0 ? void 0 : element.type)) {
        return true;
    }
    if (element === null || element === void 0 ? void 0 : element.props) {
        return interactiveProps.some(prop => prop in element.props);
    }
    return false;
};
const initializeValues = (children) => {
    const initialValues = [];
    const initialize = (child) => {
        var _a;
        if (!child) {
            return;
        }
        if (isInteractiveElement(child)) {
            const { defaultValue, value, selected } = child.props;
            initialValues.push(defaultValue || value || selected || '');
        }
        else if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.children) {
            Children.forEach(child.props.children, initialize);
        }
    };
    Children.forEach(children, initialize);
    return initialValues;
};
const Group = forwardRef(function Group({ as: Element = Fragment, children, className, onChange = () => {
    // does nothing
}, onBlur = () => {
    // does nothing
}, ...rest }, ref) {
    let indexRef = 0;
    const [values, setValues] = useState(() => initializeValues(children));
    function handleOnChange({ evt, index }) {
        var _a;
        const newValues = [...values];
        newValues[index] = (_a = evt.target) === null || _a === void 0 ? void 0 : _a.value;
        setValues(newValues);
        const event = new CustomEvent('change', {
            detail: { values: newValues }
        });
        onChange(event);
    }
    function handleOnBlur() {
        const event = new CustomEvent('blur', {
            detail: { values }
        });
        onBlur(event);
    }
    function cloneWithHandlers(child) {
        var _a;
        if (!child) {
            return child;
        }
        if (!isInteractiveElement(child)) {
            if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.children) {
                return cloneElement(child, {
                    children: Children.map(child.props.children, nestedChild => cloneWithHandlers(nestedChild))
                });
            }
            return child;
        }
        const { onChange, onBlur } = child.props;
        const currentIndex = indexRef;
        const clonedElement = cloneElement(child, {
            onChange: callAll(onChange, (evt) => handleOnChange({ evt, index: currentIndex })),
            onBlur: callAll(onBlur, handleOnBlur)
        });
        indexRef += 1;
        return clonedElement;
    }
    return (_jsx(Element, { ...rest, ...(Element !== Fragment && { className, ref }), children: Children.map(children, child => (isValidElement(child) ? cloneWithHandlers(child) : child)) }));
});
Group.displayName = GROUP;
export { Group };
//# sourceMappingURL=Group.js.map